<template>
  <div class="page-wrapper" style="overflow-y: auto;">
    <div class="container">
      <h4>청구처 리스트
        <div v-show="editItem == false" class="btn btn-primary" v-on:click="openNewCustomerForm()">Add</div>
      </h4>
      <table class="table">
        <tr>
          <th>#</th>
<!--          <th>User Name</th>-->
          <th>Title</th>
          <th>Email</th>
          <th>Contact</th>
          <th>Address</th>
         <th></th>
        </tr>
        <tr v-for="(item, index) in items">
          <td class="text-left">{{index+1}}</td>
<!--          <td class="text-left">{{item.user_name}}</td>-->
          <td class="text-left">{{item.title}}</td>
          <td class="text-left">{{item.email}}</td>
          <td class="text-left">{{item.contact}}</td>
          <td class="text-left">{{item.address}} {{item.postCode}}</td>
          <td>
            <button v-show="editItem == false" type="button" class="btn btn-primary"
                    v-on:click="editCustomer(item.id)">Edit
            </button>
          </td>

        </tr>
      </table>
    </div>
    <div style="position: fixed; top:0; left: 0; width: 100%; height: 100%; background-color: rgba(0,0,0,0.6);" v-if="editItem != false">
      <div style="position: absolute; top:50%; left: 50%; width: calc(100% - 20px); max-width: 1500px; height: 90%; transform: translate(-50%, -50%); padding:20px; overflow-y: auto; background-color: white;" v-on:click.stop="dummy">
        <div class="container">
          <div class="row">
            <div class="col-12">
              <h4 v-if="editItem.id == 0">신규등록</h4>
              <h4 v-if="editItem.id > 0">업체수정 {{editItem.title}}</h4>
            </div>
          </div>
        </div>
        <div class="container text-left">

          <div class="row input-container">

            <div class="col-12">
              업체명
              <input type="text" class="form-control" v-model="editItem.title" placeholder="Title"/>
            </div>

            <div class="col-12">
              이메일
              <input type="text" class="form-control" v-model="editItem.email" placeholder="Email"/>
            </div>
            <div class="col-12">
              Contact
              <input type="text" class="form-control" v-model="editItem.contact" placeholder="Contact"/>
            </div>
            <div class="col-12">
              PIC
              <input type="text" class="form-control" v-model="editItem.personInCharge" placeholder="Person in charge"/>
            </div>
            <div class="col-12">
              Address
              <textarea class="form-control" v-model="editItem.address" rows="4"></textarea>
            </div>
            <div class="col-12">
              Post Code
              <input class="form-control" v-model="editItem.postCode" rows="4"></input>
            </div>
          </div>

          <div class="row" style="margin-top:30px;">
            <div class="col-6">
              <div class="btn btn-secondary" v-on:click="editItem = false">Close</div>
            </div>
            <div class="col-6">
              <div v-show="editItem.id == 0" class="btn btn-primary" v-on:click="submitCustomerForm()">Create</div>
              <div v-show="editItem.id > 0" class="btn btn-primary" v-on:click="submitCustomerForm()">Update</div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
  import {getCustomers, updateCustomer, getCustomer} from "../api/customers";
  import {showDialog} from "../api/utils";

  export default {
    name: "Customers",
    data() {
      return {
        msg: 'Admin Customers',
        user: false,
        items: [],

        editItem: false,
        reg: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/,
      }
    },
    created: function () {

    },
    mounted() {
      this.getCustomers();
    },
    methods: {
        dummy: function() {

        },
        getCustomers: function () {
          let self = this;
          getCustomers()
          .then(function(data) {
            if(data.success == true) {
              self.$data.items = data.item;
              // self.$data.customers = data.item;
            } else {

              // window.aler(data.message);
            }
          })
          .catch(function(err) {
            showDialog(err, "ERROR");
            // window.alert("ERROR " + err);
          })
        },
        editCustomer: function(id) {
          let self = this;
          getCustomer(id)
          .then(function(data) {
            if(data.success === true) {
              self.$data.editItem = data.item;
            } else {
              showDialog(data.message);
            }
          })
          // this.$data.newCustomer = JSON.parse(JSON.stringify(this.$data.customers[index]));

        },
        openNewCustomerForm: function () {
          this.$data.editItem = {
            id: 0,
            title: '',
            postCode: '',
            address: '',
            contact: '',
            email:'',
            personInCharge:'',

          };
        },
        submitCustomerForm: function() {

          let self = this;
          let isNew = false;
          if(this.$data.editItem.id === 0) {
            isNew = true;
          }
          updateCustomer(this.$data.editItem)
          .then(function(data) {
            if(data.success == true) {

              if(isNew) {
                self.$data.items.push(data.item);
                self.$data.editItem = false;
              }
              for(let i = 0 ; i < self.$data.items.length ; i++) {
                if(self.$data.items[i].id == item.id) {
                  self.$data.items.splice(i, 1, item);
                  self.$data.editItem = false;
                  return;
                }
              }

            } else {
              showDialog(data.message);
            }
          })
          .catch(function(err) {
            showDialog(err, "ERROR");
          })

        },
        isEmailValid: function(email) {
          if(email == "") {
            return false;
          }
          if(this.$data.reg.test(email)) {
            return true;
          }
          return false;
        },
      }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Customers.vue